import { Card, CardContent, CardHeader } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ChangeAvatar from '@views/ManageAccount/Profile/ChangeAvatar';

import { type GetOrganizationProfileQuery } from 'generated/account.generated';

import OrgProfileForm from './ProfileForm';

const messages = defineMessages({
  profileTitle: {
    id: 'organization.setting.profile.title',
    defaultMessage: '{name} Information',
  },
  profileBrandSubtitle: {
    id: 'profileBrandSettings.profileBrandSubtitle',
    defaultMessage: "Display as your organization's profile photo.",
  },
});

interface OrganizationProfileProps {
  account?: GetOrganizationProfileQuery['getAccountRecord'];
  loading?: boolean;
}

export default function OrganizationProfile({
  account,
  loading,
}: OrganizationProfileProps) {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <CardHeader
        title={formatMessage(messages.profileTitle, {
          name: account?.account_name,
        })}
        subheader={formatMessage(messages.profileBrandSubtitle)}
      />
      <CardContent>
        <ChangeAvatar
          account={{
            account_id: account?.account_id ?? '',
            account_name: account?.account_name,
            profile_picture: account?.profile_picture,
          }}
          logo={false}
          loading={loading ?? false}
        />
        <OrgProfileForm loading={loading} orgProfile={account} />
      </CardContent>
    </Card>
  );
}
